module.exports = __webpack_public_path__ + "media/videos/video-74ea7f09eaaec12ecc7bfd202ba92e60.ogg";